// Метаданные на каждую страницу. Раньше они были одни на весь сайт в index.html —
// теперь у каждой страницы свой title/description, что и даёт корректный SEO.
const SITE = '51north';
const BASE_URL = 'https://51north.io';
const DEFAULT_OG = `${BASE_URL}/og-image.jpg`;

const staticMeta = {
  '/': {
    title: '51north — Schneller bauen. Mit System.',
    description:
      'Die serielle Modulbauweise für Ihr neues Eigenheim. Festpreisgarantie, kompromisslose Bauqualität und ein schneller, sorgenfreier Einzug.',
  },
  '/impressum': {
    title: 'Impressum — 51north',
    description: 'Impressum und Anbieterkennzeichnung der 51north Real Estate GmbH',
  },
  '/datenschutz': {
    title: 'Datenschutz — 51north',
    description: 'Datenschutzerklärung der 51north Real Estate GmbH',
  },
  '/cookie-richtlinien': {
    title: 'Cookie-Richtlinien — 51north',
    description: 'Informationen zur Verwendung von Cookies auf 51north.io.',
  },
  '/danke': {
    title: 'Vielen Dank — 51north',
    description: 'Ihre Anfrage wurde erfolgreich übermittelt.',
  },
};

// Заголовки страниц проектов (id → название). Используется для /project/:id.
const projectTitles = {
  'mittelring-13': 'Mittelring 13, Leipzig',
};

export function getMeta(pathname) {
  if (pathname.startsWith('/project/')) {
    const id = pathname.replace('/project/', '').replace(/\/$/, '');
    const name = projectTitles[id] || 'Projekt';
    return {
      title: `${name} — 51north`,
      description: `${name}: Referenzprojekt von 51north in serieller, industrieller Modulbauweise.`,
    };
  }
  return staticMeta[pathname] || staticMeta['/'];
}

export { SITE, BASE_URL, DEFAULT_OG };
